const STORAGE_KEY = 'authorizedConnections';

function readAuthorizedConnections(): string[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function isConnectionAuthorized(
  connectionId: string | undefined | null,
): boolean {
  if (!connectionId) return false;
  return readAuthorizedConnections().includes(connectionId);
}

export function markConnectionAuthorized(connectionId: string): void {
  const connections = readAuthorizedConnections();
  if (connections.includes(connectionId)) return;
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify([...connections, connectionId]),
  );
}
